export const fiscalBoard = {
	selectMonth: "Seleccione un mes",
	addPlace: "Agregar local",
	selectPlace: "Seleccione un local",
	nfceIssued: "NFC-e emitidas",
	nfseIssued: "NFS-e emitidas",
	nfce: "NFC-e",
	nfse: "NFS-e",
	fiscalProfile: "Emisión por perfil fiscal",
	column: {
		date: "Fecha",
		errorType: "Tipo de error",
		type: "Tipo",
		value: "Valor",
		total: "Total Emitible",
	},
	issuingErrors: "Errores de emisión",
};
